export default [
  '<header class="container-fluid">',
  '  <nav class="navbar navbar-light bg-transparent border-bottom">',
  '    <div class="container-fluid">',
  '     <a class="navbar-brand" href="#">',
  '       <img src="https://res.cloudinary.com/missada/image/upload/v1645340728/Tf.js%20Playground/tfjs_playground_smaller_alt_3.png" alt="" width="30" height="30" class="d-inline-block align-text-top">',
  '       Am I The Drama',
  '       <span class="sub-heading">',
  '         Powered by TF.js',
  '       </span>',
  '     </a>',
  '    </div>',
  '  </nav>',
  '</header>',
  '<main>',
  '  <div class="container pt-3">',
  '    <h1>TensorFlow.js toxicity classifier playground.</h1>',
  '    <p>',
  '      This playground uses the TensorFlow.js toxicity model, which classifies text according to whether it exhibits offensive attributes (i.e. profanity, sexual explicitness) to detect toxic content in it.',
  '    </p>',
  '    <form id="toxicityModelForm">',
  '      <div class="mb-3">',
  '        <label for="paragraph" class="form-label">Enter a paragraph of text to detect the toxic content in it.</label>',
  '        <textarea class="form-control" id="paragraph" rows="3" name="paragraph" required></textarea>',
  '      </div>',
  '      <div class="mb-3">',
  '        <button type="submit" class="btn tp-btn-amber" id="submit">Submit</button>',
  '      </div>',
  '    </form>',
  '',
  '    <div class="card">',
  '     <div class="card-body">',
  '        <div id="analysis">',
  '          <h2>Analysis Summary</h2>',
  '          <div id="analysisSummary">',
  '            <p id="analysisSummaryText"></p>',
  '          </div>',
  '          <div id="analysisSummaryDetails"></div>',
  '        </div>',
  '     </div>',
  '    </div>',
  '  </div>',
  '</main>',
  '',
  '',
].join('\n');
